<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .setting__title Приоритет обработчиков
          .payment-settings__list
            .payment-setting__container.mb5(
              v-for="(setting, system) in handlers_priority"
              :key="`handler-priority-${system}`"
            )
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .handlers-priority__container
                  .handler-priority__container(v-for="(handler, index) in handlers_priority[system]" :key="`handler-priority-${system}-${handler}`")
                    .handler__name {{ handler }}
                    .handler-priority__btns
                      el-button(
                        v-if="index !== 0"
                        circle
                        size="mini"
                        icon="el-icon-top"
                        @click="changeHandlerPriority(index, index - 1, system)"
                      )
                      el-button(
                        v-if="index !== handlers_priority[system].length - 1"
                        circle
                        size="mini"
                        icon="el-icon-bottom"
                        @click="changeHandlerPriority(index, index + 1, system)"
                      )
                      el-button(
                        circle
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteHandlerPriorityFromSystem(index, system)"
                        type="danger"
                      )
                  .handler-add__container(v-if="handlersPriorityLeftSystems[system].available")
                    el-select(v-model="addingHandlersPriority[system]")
                      el-option(
                        v-for="addingHandler in handlersPriorityLeftSystems[system].list"
                        :label="addingHandler"
                        :value="addingHandler"
                        :key="`adding-handler-${system}-${addingHandler}`"
                        size="mini"
                      )
                    .handler-add__btn
                      el-button(
                        circle
                        icon="el-icon-plus"
                        size="mini"
                        :disabled="!addingHandlersPriority[system]"
                        @click="addHandlerPriorityToSystem(system)"
                        type="success"
                      )
        .setting__container
          .setting__title Приоритет платежных систем
            .handlers-priority__container
              .handler-priority__container(v-for="(ps, index) in payment_systems_priority" :key="`ps-priority-${ps}`")
                .handler__name {{ paymentSystems[ps] }}
                .handler-priority__btns
                  el-button(
                    v-if="index !== 0"
                    circle
                    size="mini"
                    icon="el-icon-top"
                    @click="changePaymentSystemPriority(index, index - 1)"
                  )
                  el-button(
                    v-if="index !== payment_systems_priority.length - 1"
                    circle
                    size="mini"
                    icon="el-icon-bottom"
                    @click="changePaymentSystemPriority(index, index + 1)"
                  )
                  el-button(
                    circle
                    size="mini"
                    icon="el-icon-delete"
                    @click="deletePaymentSystemFromPriority(index)"
                    type="danger"
                  )
              .handler-add__container(v-if="paymentSystemsPriorityLeftSystems.length > 0")
                el-select(v-model="addingPaymentSystemPriority")
                  el-option(
                    v-for="addingPs in paymentSystemsPriorityLeftSystems"
                    :label="paymentSystems[addingPs]"
                    :value="addingPs"
                    :key="`adding-ps-${addingPs}`"
                    size="mini"
                  )
                .handler-add__btn
                  el-button(
                    circle
                    icon="el-icon-plus"
                    size="mini"
                    :disabled="!addingPaymentSystemPriority"
                    @click="addPaymentSystemToPriority()"
                    type="success"
                  )
              el-button(
                v-if="canSavePaymentSystemsPriority"
                type="success"
                size="mini"
                @click="savePaymentSystemPriority"
              ) Сохранить
        .setting__container
          .setting__title Лимиты платежных систем
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in payments_amounts" :key="`payments-amounts-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .limits__container
                  el-input(v-model="payments_amounts[system].min" type="number" :min="0")
                  el-input(v-model="payments_amounts[system].max" type="number" :min="0")
            .mt10
              el-button(
                size="mini"
                type="primary"
                @click="editPaymentsSettings('payments_amounts')"
              ) Обновить
        .setting__container
          .setting__title Токены авторизации SD
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in saudi_tokens" :key="`saudi-payments-tokens-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="saudi_tokens[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('saudi_tokens')"
                  ) Изменить
        .setting__container
          .setting__title Токены авторизации EM
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in emirates_tokens" :key="`emirates-payments-tokens-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="emirates_tokens[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('emirates_tokens')"
                  ) Изменить
        .setting__container
          .setting__title Токены авторизации BR
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in bridge_tokens" :key="`bridge-payments-tokens-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="bridge_tokens[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('bridge_tokens')"
                  ) Изменить
        .setting__container
          .setting__title Секретные ключи BR
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in bridge_secret_keys" :key="`bridge-secret-key-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="bridge_secret_keys[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('bridge_secret_keys')"
                  ) Изменить
        .setting__container
          .setting__title Клиентские ID Honey
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in honey_client_id" :key="`honey-client-id-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="honey_client_id[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('honey_client_id')"
                  ) Изменить
        .setting__container
          .setting__title Секретные ключи Honey
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in honey_client_secret" :key="`honey-client-secret-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="honey_client_secret[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('honey_client_secret')"
                  ) Изменить
        .setting__container
          .setting__title Подпись шифрования Honey
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in honey_client_signature" :key="`honey-client-signature-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="honey_client_signature[system]")
                .payment-edit__button
                  el-button(
                    size="mini"
                    type="primary"
                    @click="editPaymentsSettings('honey_client_signature')"
                  ) Изменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_SETTINGS, UPDATE_SETTING } from '@/store/const/settings';

export default {
  name: 'Settings',
  data() {
    return {
      saudi_tokens: {},
      emirates_tokens: {},
      bridge_tokens: {},
      bridge_secret_keys: {},
      honey_client_id: {},
      honey_client_secret: {},
      honey_client_signature: {},
      handlers_priority: {
        card: [],
        sbp: [],
        sim: [],
        bank_account: [],
        qr: [],
        foreign_card: [],
        foreign_sbp: [],
        interbank: [],
      },
      payments_amounts: {
        card: {},
        sbp: {},
        sim: {},
        bank_account: {},
        qr: {},
        foreign_card: {},
        foreign_sbp: {},
        interbank: {},
      },
      addingHandlersPriority: {
        card: '',
        sbp: '',
        sim: '',
        bank_account: '',
        qr: '',
        foreign_card: '',
        foreign_sbp: '',
        interbank: '',
      },
      payment_systems_priority: [],
      addingPaymentSystemPriority: '',
      originalPaymentSystemPriorityString: '[]',
      interbanks_selected_bank: '',
      available_interbanks: {},
    };
  },
  async mounted() {
    await this.loadAndSetSettings();
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('settings', ['paymentSystems', 'handlers']),
    isLoading() {
      return this.loading(LOAD_SETTINGS) === 'loading';
    },
    handlersPriorityLeftSystems() {
      const result = {};
      for (const system of Object.keys(this.paymentSystems)) {
        const handlersLeft = this.handlers.filter((handler) => !this.handlers_priority[system].includes(handler));
        result[system] = { available: handlersLeft.length > 0, list: handlersLeft };
      }
      return result;
    },
    paymentSystemsPriorityLeftSystems() {
      return Object.keys(this.paymentSystems).filter((c) => !this.payment_systems_priority.includes(c));
    },
    canSavePaymentSystemsPriority() {
      return JSON.stringify(this.payment_systems_priority) !== this.originalPaymentSystemPriorityString;
    },
  },
  methods: {
    ...mapActions('settings', {
      loadSettings: LOAD_SETTINGS,
      updateSetting: UPDATE_SETTING,
    }),
    async loadAndSetSettings() {
      const request = await this.loadSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
          if (settingName === 'payment_systems_priority') {
            this.originalPaymentSystemPriorityString = JSON.stringify(settings[settingName]);
          }
        }
      }
    },
    async requestSettingUpdate(name, setting) {
      const request = await this.updateSetting({ name, setting });
      if (request.success) {
        this.$message.success('Настройки успешно обновлены');
        await this.loadAndSetSettings();
        return true;
      } else {
        this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        return false;
      }
    },
    async editPaymentsSettings(settingsName) {
      return await this.requestSettingUpdate(settingsName, this[settingsName]);
    },
    async editSetting(settingsName, switchOnFail) {
      const isUpdateSuccess = await this.requestSettingUpdate(settingsName, this[settingsName]);
      if (!isUpdateSuccess && switchOnFail) {
        this[settingsName] = !this[settingsName];
      }
    },
    async changeHandlerPriority(index, newIndex, system) {
      this.swapHandlerPriority(index, newIndex, system);
      const wasChanged = await this.editPaymentsSettings('handlers_priority');
      if (!wasChanged) {
        this.swapHandlerPriority(index, newIndex, system);
      }
    },
    swapHandlerPriority(index, newIndex, system) {
      const oldValue = this.handlers_priority[system][index];
      const newPriority = [...this.handlers_priority[system]];

      newPriority[index] = newPriority[newIndex];
      newPriority[newIndex] = oldValue;

      this.handlers_priority[system] = newPriority;
    },
    async addHandlerPriorityToSystem(system) {
      if (this.handlers_priority[system].includes(this.addingHandlersPriority[system])) {
        return this.$message.warning('Указанный обработчик уже используется в приоритезации платежной системы');
      }
      this.handlers_priority[system].push(this.addingHandlersPriority[system]);
      const wasChanged = await this.editPaymentsSettings('handlers_priority');
      if (wasChanged) {
        this.addingHandlersPriority[system] = '';
      } else {
        this.handlers_priority[system].splice(this.handlers_priority[system].length - 1, 1);
      }
    },
    async deleteHandlerPriorityFromSystem(index, system) {
      this.$confirm(
        `Вы уверены, что хотите удалить обработчик ${this.handlers_priority[system][index]} из платежной системы ${system}?`,
        'Подтверждение',
      )
        .then(async () => {
          const oldPriority = [...this.handlers_priority[system]];
          this.handlers_priority[system].splice(index, 1);
          const wasChanged = await this.editPaymentsSettings('handlers_priority');
          if (!wasChanged) {
            this.handlers_priority[system] = oldPriority;
          }
        })
        .catch(() => {
          this.$message.info('Удаление отменено');
        });
    },
    async changePaymentSystemPriority(index, newIndex) {
      const newArr = [...this.payment_systems_priority];
      const oldValue = this.payment_systems_priority[index];
      newArr[index] = newArr[newIndex];
      newArr[newIndex] = oldValue;
      this.payment_systems_priority = newArr;
    },
    async addPaymentSystemToPriority() {
      this.payment_systems_priority = [...this.payment_systems_priority, this.addingPaymentSystemPriority];
      this.addingPaymentSystemPriority = '';
    },
    async deletePaymentSystemFromPriority(index) {
      this.payment_systems_priority.splice(index, 1);
    },
    async savePaymentSystemPriority() {
      await this.editSetting('payment_systems_priority');
    },
    startUpdateSelectedInterbank(bank) {
      this.$confirm(
        `Вы уверены, что хотите изменить используемый внутребанк на ${this.available_interbanks[bank]}`,
        'Подтверждение изменения внутребанка',
      )
        .then(async () => {
          await this.editSetting('interbanks_selected_bank');
        })
        .catch(() => {
          this.$message.info('Изменение используемого внутребанка отменено');
        });
    },
  },
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 240px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f;
}

.setting__block {
  margin-bottom: 10px;
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.settings-ads-ids__add button {
  margin-left: 5px;
}

.handlers-priority__container {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.handler-priority__container {
  display: flex;
  padding: 4px;
  margin-bottom: 2px;
  align-items: center;
}

.handler-priority__btns {
  margin-left: 5px;
}

.handler-add__container {
  display: flex;
  align-items: center;
}

.handler-add__btn {
  width: 30px;
  height: 30px;
  margin: auto 5px;
}

.payment-setting__container {
  border: 1px solid #dcdfe6;
  padding: 4px;
}

.payment-setting__container .payment-edit__button {
  margin-top: 5px;
}
</style>
